import Microlearning from './component'
export default Microlearning
